import { DataBean } from "../DataBean";

export class QualityReprocessingItem extends DataBean {

  public async getQualityReprocessingItemCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityReprocessingItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityReprocessingItemRender( page: number, rows: number, properties: any, FromDate: any, UptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityReprocessingItemRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, FromDate, UptoDate]
    );
  }

  public async getQualityReprocessingItemCountByLabour( page: number, rows: number, properties: any, FromDate: any, UptoDate: any  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityReprocessingItemCountByLabour_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, rows, properties, FromDate, UptoDate ]
    );
  }

  public async deleteQualityReprocessingItem(idqualityreprocessing: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityReprocessingItem_Number", [idqualityreprocessing]);
  }

  public async importReprocessReviewItems(IDEmployee: number, data: string, idQualityReprocessing: number, year: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "java.util.List_importReprocessReviewItems_Number_String_Number_Number", [IDEmployee, data, idQualityReprocessing, year]);
  }

  public async updateQualityReprocessingItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityReprocessingItem_updateQualityReprocessingItem_com.orange.finance.processcontract.bean.QualityReprocessingItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityReprocessingItem",
        },
      ]
    );
  }
}
